import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import '@/App.css';
import LandingPage from '@/pages/LandingPage';
import BookingFlow from '@/pages/BookingFlow';
import BookingSuccess from '@/pages/BookingSuccess';
import AdminLogin from '@/pages/admin/AdminLogin';
import AuthCallback from '@/pages/admin/AuthCallback';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import { Toaster } from 'sonner';

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/book" element={<BookingFlow />} />
      <Route path="/booking-success" element={<BookingSuccess />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
